import React from 'react';  
import { Redirect } from 'react-router-dom';

import auth from 'base/auth';

const Logout = (props) => { 
  auth.clearAppStorage();
  return (<Redirect to="/" />)
};

export default Logout;  


// WEBPACK FOOTER //
// ./src/base/views/Logout.js